/**
 * @file Shared mutable state for the active form modal.
 */

export let formItemData = {};

/**
 * Replaces active modal item data.
 * @param {object | null | undefined} nextData Next mutable form data.
 * @returns {object} Active form data.
 */
export function setFormItemData(nextData) {
    formItemData = nextData && typeof nextData === "object" ? nextData : {};
    return formItemData;
}

/**
 * Clears active modal item data.
 * @returns {void}
 */
export function clearFormItemData() {
    formItemData = {};
}
